export function getActiveLiveEvent() {
    return window.__UpshowState && window.__UpshowState.activeLiveEvent && window.__UpshowState.activeLiveEvent;
}